angular
    .module('components.util')
    .service('trsFileService', ['md5', function(md5) {
        return {
            getFileIconImg: getFileIconImg,
            getUniqueId: getUniqueId,
            getFileIcon: getFileIcon
        };

        /**
         * [getFileIcon 根据文件名获取文件图标-iconfont]
         *
         * @param   {[type]}  name  [name description]
         *
         * @return  {[type]}        [return description]
         */
        function getFileIcon(name) {
            const type = getFileType(name);
            const IconsMap = {
                'pic': 'icon-noticetupian1',
                'doc': 'icon-noticewendang',
                'video': 'icon-noticeshipin',
                'voice': 'icon-noticeyinpin1',
                'zip': 'icon-yunpanlogo-',
            };
            return IconsMap[type];
        }

        /**
         * [getFileIconImg 根据文件名获取文件图标-图片格式]
         *
         * @param   {[type]}  name  [name description]
         *
         * @return  {[type]}        [return description]
         */
        function getFileIconImg(name){
            const type = getFileType(name);
            return './static/extIcon/' + type + '.png';
        }

        /**
         * [getFileType 根据文件名获取文件类型]
         *
         * @param   {[type]}  name  [name description]
         *
         * @return  {[type]}        [return description]
         */
        function getFileType (name) {
            name = name.toLowerCase();
            if (/\.(gif|jpg|jpeg|png)$/.test(name)) return 'pic';
            if (/\.(doc|docx|xls|xlsx|pdf)$/.test(name)) return 'doc';
            if (/\.(mp4|mov)$/.test(name)) return 'video';
            if (/\.(mp3|wma|rmvb|flv|mpg)$/.test(name)) return 'voice';
            if (/\.(rar|zip|arj|gz|winzip|z)$/.test(name)) return 'zip';
            return 'doc';
        };

        /**
         * [getUniqueId 获取唯一ID]
         *
         * @param   {[type]}  str  [str description]
         *
         * @return  {[type]}       [return description]
         */
        function getUniqueId(str) {
            return md5.createHash(str);
        }
    }]);